import React from 'react';
import './network.css';

const NetworkSVG = ({ className = '', small = false }) => {
  const cls = `network-svg ${className} ${small ? 'is-small' : ''}`;
  return (
    <svg className={cls} viewBox="0 0 360 240" preserveAspectRatio="xMidYMid meet" role="img" aria-hidden="true">
      <defs>
        <linearGradient id="g1" x1="0" x2="1">
          <stop offset="0" stopColor="var(--accent)" />
          <stop offset="1" stopColor="var(--accent-2)" />
        </linearGradient>
      </defs>

      <g className="edges" stroke="url(#g1)" strokeWidth="1.6" strokeLinecap="round" fill="none" opacity="0.9">
        <line x1="40" y1="40" x2="140" y2="60" className="edge" />
        <line x1="140" y1="60" x2="220" y2="30" className="edge" />
        <line x1="80" y1="120" x2="220" y2="30" className="edge" />
        <line x1="40" y1="40" x2="80" y2="120" className="edge" />
        <line x1="220" y1="30" x2="300" y2="90" className="edge" />
        <line x1="80" y1="120" x2="170" y2="180" className="edge" />
        <line x1="170" y1="180" x2="300" y2="90" className="edge" />
      </g>

      <g className="nodes" fill="url(#g1)">
        <circle className="node" cx="40" cy="40" r="5" />
        <circle className="node" cx="140" cy="60" r="6" />
        <circle className="node" cx="220" cy="30" r="5" />
        <circle className="node" cx="80" cy="120" r="5" />
        <circle className="node" cx="300" cy="90" r="6" />
        <circle className="node" cx="170" cy="180" r="5" />
      </g>
    </svg>
  );
};

export default NetworkSVG;
